/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

/**
 * Local agent notification payload.
 */
export type HookNotificationData = {
  /**
   * Notification message.
   */
  message?: string | undefined;
  /**
   * Notification title.
   */
  title?: string | undefined;
  /**
   * Notification type.
   */
  type?: string | undefined;
};

/** @internal */
export type HookNotificationData$Outbound = {
  message?: string | undefined;
  title?: string | undefined;
  type?: string | undefined;
};

/** @internal */
export const HookNotificationData$outboundSchema: z.ZodMiniType<
  HookNotificationData$Outbound,
  HookNotificationData
> = z.object({
  message: z.optional(z.string()),
  title: z.optional(z.string()),
  type: z.optional(z.string()),
});

export function hookNotificationDataToJSON(
  hookNotificationData: HookNotificationData,
): string {
  return JSON.stringify(
    HookNotificationData$outboundSchema.parse(hookNotificationData),
  );
}
